import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Typography } from '@mui/material';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
import { portalContentMaxWidthSx, portalPageHorizontalPaddingSx } from '../../../theme/portalLayout';
/**
 * DividerBlock – visual separator. Supports label + gradient.
 */
const DividerBlock = ({ label, gradient, style = 'solid', thickness = 1, spacing = 2, borderColor, paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, width = '100%', componentAlignment = 'left', }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 2,
            paddingBottom: paddingBottom || 2,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: {
                ...portalContentMaxWidthSx,
                ...(maxWidth != null ? { maxWidth } : {}),
                ...portalPageHorizontalPaddingSx,
            }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), _jsx(Box, { sx: { py: spacing }, children: _jsx(Divider, { sx: {
                            borderColor: borderColor || 'divider',
                            borderWidth: thickness,
                            borderStyle: style,
                            width,
                            mx: componentAlignment === 'center' ? 'auto' : componentAlignment === 'right' ? 'auto' : 0,
                            ml: componentAlignment === 'right' ? 'auto' : 0,
                        } }) })] }) }));
};
export default DividerBlock;
